import { ACTIONS } from '../constants';
import { getBreedVariant } from '../functions';

export const isRenderableInterstitialContent = content =>
  Boolean(content?.mobileImage?.src && content?.desktopImage?.src);

export const hasRenderableInterstitial = (interstitial, breeds = []) =>
  isRenderableInterstitialContent(
    getBreedVariant(interstitial?.content, breeds),
  );

export const advanceFromQuestion = ({
  send,
  showInterstitial,
  interstitial,
  fromQuestion,
  pet,
  pets,
  nextAction,
}) => {
  if (
    showInterstitial &&
    hasRenderableInterstitial(interstitial, pet?.breeds)
  ) {
    send(
      ACTIONS.toInterstitial({
        fromQuestion,
        interstitial,
        pet,
        pets,
      }),
    );
    return;
  }

  send(nextAction);
};
